"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M3.5 5C1.57 5 0 6.57 0 8.5S1.57 12 3.5 12 7 10.43 7 8.5 5.43 5 3.5 5zm9 0C10.57 5 9 6.57 9 8.5s1.57 3.5 3.5 3.5S16 10.43 16 8.5 14.43 5 12.5 5z"];
//# sourceMappingURL=ungroup-objects.js.map